import React from 'react';
import ReactDOM from 'react-dom';
import { BrowserRouter } from 'react-router-dom';



//------------------ Slot Machine Lec 28  -- Refrence App --------------------------
//     import SlotMachine from './compunents/SlotMachine';

//  ReactDOM.render(
//     <SlotMachine />

// ,document.getElementById("root")
// );



//----------------- Hooks Current Clock Lec 31 ------------------------

// import Clock from './App';

// ReactDOM.render(
//     <Clock time="Time is-->"/>
// ,document.getElementById('root')
// );

//----------------- Digital Clock lec 32-------------------------
// import DClock from './App';

// ReactDOM.render(
//     <DClock />
// ,document.getElementById('root')
// );

// //----------------- Forms lec 34-------------------------
// import '../node_modules/bootstrap/dist/css/bootstrap.min.css';
// import Form from './App';

// ReactDOM.render(
//     <Form />
// ,document.getElementById('root')
// );


//----------------- Forms lec 35-------------------------
// import Form1 from './App';

// ReactDOM.render(
//     <Form1 />
// ,document.getElementById('root')
// );

// // //----------------- Bootstarp Grand-------------------------
// import '../node_modules/bootstrap/dist/css/bootstrap.min.css';
// import { BrowserRouter } from 'react-router-dom';
import Bootstrap from './App';

ReactDOM.render(
    <>
     <BrowserRouter>
        <Bootstrap />
     </BrowserRouter>
    </>
,document.getElementById('root')
);

// //----------------- Restaurant-------------------------

// import { BrowserRouter } from 'react-router-dom';
// import Restaurant from './App';


// ReactDOM.render(
//     <>
     
//      <BrowserRouter>
//         <Restaurant />
//      </BrowserRouter>
//     </>
// ,document.getElementById('root') 
// );



//----------------- Project1-------------------------
// import '../node_modules/bootstrap/dist/css/bootstrap.min.css';
// import '../node_modules/bootstrap/dist/js/bootstrap.bundle';
// import { BrowserRouter } from 'react-router-dom';
// import Project1 from './App';

// ReactDOM.render(
//     <>
     
//      <BrowserRouter>
//         <Project1 />
        
//      </BrowserRouter>
//     </>
// ,document.getElementById('root')
// );


// //-----------------Tester Form-------------------------
// import '../node_modules/bootstrap/dist/css/bootstrap.min.css';
// import '../node_modules/bootstrap/dist/js/bootstrap.bundle.min';

// import App from './App';

// ReactDOM.render(
// <>
//     <BrowserRouter>
//      <App />
//     </BrowserRouter>
// </>
    
// ,document.getElementById('root') 
// );

    